// breakpoint settings

export const MOBILE_BREAKPOINT = 768;
export const NAV_BREAKPOINT = 960;
